const autoNgTemplateLoaderTemplate1 = require('./applicationsDatatable.html');

import './applicationsDatatable.css';

angular.module('portainer.kubernetes').component('kubernetesApplicationsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesApplicationsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    settingsKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
    refreshCallback: '<',
    onPublishingModeClick: '<',
    isPrimary: '<',
    namespaces: '<',
    namespace: '<',
    onChangeNamespaceDropdown: '<',
    isAppsLoading: '<',
    isSystemResources: '<',
    isVisible: '<',
    setSystemResources: '<',
    hideStacksFunctionality: '<',
  },
});
